/**
 * Nodera Health brand mark — three-node network around a central hub.
 * Pure SVG, color-prop driven, scales to any size. Mirrors the wordmark logo at
 * /artifacts/cdlhamay_nodera-white-square.png.
 */
export default function NoderaMark({
  size = 32,
  color = "currentColor",
  className = "",
  ariaLabel = "Nodera Health",
  ...rest
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={ariaLabel}
      className={className}
      {...rest}
    >
      {/* connecting struts (drawn first so the nodes overlap them cleanly) */}
      <path
        d="M32 34 V 11"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M32 34 L 14 52"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M32 34 L 50 52"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      />

      {/* central hub */}
      <circle cx="32" cy="34" r="7" fill={color} />

      {/* satellite nodes */}
      <circle cx="32" cy="10" r="5" fill={color} />
      <circle cx="13" cy="52" r="4.5" fill={color} />
      <circle cx="51" cy="52" r="4.5" fill={color} />
    </svg>
  );
}
